import Component from '@glimmer/component';
import { t } from 'ember-intl';
import ParityOtaWithIcon from 'lumen/components/parity/ota-with-icon';

interface GeneralTablesCellsCellMetaOtaSignature {
  Args: {
    ota: unknown;
    source: unknown;
  };
}

export default class GeneralTablesCellsCellMetaOta extends Component<GeneralTablesCellsCellMetaOtaSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDirectlyShopped() {
    return this.args.ota === this.args.source;
  }

  <template>
    {{#if this.isDirectlyShopped}}
      {{t "parity_analytics.directly_shopped"}}
    {{else}}
      {{! @glint-expect-error: Incorrect type }}
      <ParityOtaWithIcon @otaId={{@source}} @size="small" />
    {{/if}}
  </template>
}
